<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import CardBillingService from 'Modules/contacard/card-billing/CardBillingService';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import DataTableCurrencyColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCurrencyColumn.vue';
import DataTableBooleanColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableBooleanColumn.vue';
import CardBillingStatusColumnVue from './components/CardBillingStatusColumn.vue';
import CardBillingPaymentMethodColumnVue from './components/CardBillingPaymentMethodColumn.vue';
import CardBillingOriginColumnVue from './components/CardBillingOriginColumn.vue';

export default {
  name: 'CardBillingList',
  extends: CrudListVue,
  data: () => ({
    requestClass: CardBillingService,
    hideDelete: true,
    hideEdit: true,
    headers: [
      {
        text: 'Situação',
        value: 'status',
        component: CardBillingStatusColumnVue,
      },
      {
        text: 'Cobrança',
        value: 'paymentMethodType',
        component: CardBillingPaymentMethodColumnVue,
      },
      {
        text: 'Tipo',
        value: 'chargeOriginForm',
        component: CardBillingOriginColumnVue,
      },
      {
        text: 'Loja',
        value: 'storeName',
      },
      {
        text: 'Valor',
        value: 'amount',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Parcelas',
        value: 'installments',
      },
      {
        text: 'Documento',
        value: 'document',
      },
      {
        text: 'NSU',
        value: 'nsu',
      },
      {
        text: 'Bloqueado por fraude',
        value: 'bloqueadoPorTentativaDeFraude',
        component: DataTableBooleanColumnVue,
      },
      {
        text: 'Data da cobrança',
        value: 'date',
        component: DataTableDateColumnVue,
      },
    ],
  }),
};
</script>
